import { graphql } from '@/generated/gql';

export const BASE_COMMODITY_GROUP_LIST_QUERY = graphql(/* GraphQL */ `
  query BaseCommodityGroupList($offset: Int, $limit: Int, $filter: JSON, $order: [CommodityGroupSortOrder!]) {
    commodityGroups(offset: $offset, limit: $limit, filter: $filter, order: $order) {
      nodes {
        id
        name
        description
        orderVolumeCurrentYear
        orderCountCurrentYear
        orderVolumeLast12Months
        orderCountLast12Months
        orderVolumeLastYear
        orderCountLastYear
        orderVolumeShareCurrentYear
        orderVolumeShareLast12Months
        orderVolumeShareLastYear
        orderVolumeCumulativeCurrentYear
        orderVolumeCumulativeLast12Months
        orderVolumeCumulativeLastYear
      }
      totalCount
    }
  }
`);
